const endpoint = (property, appClass, id) => `/api/${property}/audits/${appClass}/${id}`;

export default ['api', function (api) {
    return {
        find: (appClass, id) => {
            return api.get(`${endpoint(api.property(), appClass, id)}`)
                .then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/services/audit.service.js